import React from 'react'

function BookingProgressBar({ currentStep, isEditMode = false }) {
  const steps = isEditMode 
    ? ['Service','Staff', 'Time', 'Confirm'] 
    : ['Service', 'Staff', 'Time', 'Confirm'];

  return (
    <div className="booking-progress">
      <div className="progress-steps">
        {steps.map((step, index) => {
          // Adjust step number for edit mode
          const stepNumber = index + 1;
          const isActive = isEditMode 
            ? currentStep >= stepNumber 
            : index + 1 <= currentStep;
            
          return (
            <div key={step} className={`progress-step ${isActive ? 'active' : ''}`}>
              <div className="step-number">{stepNumber}</div>
              <span className="step-label">{step}</span>
            </div>
          );
        })}
      </div>
    </div>
  )
}

export default BookingProgressBar